/**
 * Twitter/X Icon
 * 
 * Uses Font Awesome under the hood for maintained, up-to-date brand icons.
 * Note: Uses the X (formerly Twitter) icon.
 */

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXTwitter } from '@fortawesome/free-brands-svg-icons/faXTwitter';
import type { IconProps } from '../../types';

export function TwitterIcon({ 
  className, 
  size = 24, 
  color,
  'aria-label': ariaLabel = 'X (Twitter)',
}: IconProps) {
  return (
    <FontAwesomeIcon 
      icon={faXTwitter}
      className={className}
      style={{ 
        width: typeof size === 'number' ? size : undefined,
        height: typeof size === 'number' ? size : undefined,
      }}
      color={color}
      aria-label={ariaLabel}
      role="img"
    />
  );
}
